import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { CharlieButton } from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../../i18n/i18n';
import { useDoneRedirect } from '../../hooks/useDoneRedirect';
import { useLayoutData } from '../../hooks/useLayoutContext';

type Props = {
  onComplete: () => Promise<void>;
  continueInApp: boolean;
  deliveryMode: 'redirect' | 'webhook';
};

export default function DoneContent({
  onComplete,
  continueInApp,
  deliveryMode,
}: Props) {
  const { t } = useTranslation();
  const { requestType } = useLayoutData();
  const { error, completing, handleManualComplete } = useDoneRedirect(
    onComplete,
    continueInApp,
    deliveryMode,
  );

  const prefix =
    requestType === 'issuance' ? 'done.issuance' : 'done.disclosure';

  const subtitle =
    deliveryMode === 'webhook'
      ? t('done.subtitleWebhookDelivered')
      : continueInApp
        ? t(`${prefix}.subtitleCloseTab`)
        : error
          ? t('done.redirectFailed')
          : t(`${prefix}.subtitle`);

  return (
    <div className="flex flex-1 items-center justify-center w-full">
      <div className="flex flex-col items-center gap-2 text-center max-w-lg w-full">
        <div className="flex flex-col items-center gap-2.5 mb-1">
          <div className="flex items-center justify-center size-10 rounded-full bg-emerald-500">
            <FontAwesomeIcon icon={faCheck} className="size-5 text-white" />
          </div>
          <h2 className="text-2xl font-semibold text-card-foreground">
            {t(`${prefix}.title`)}
          </h2>
        </div>
        <p className="text-sm leading-5 text-muted-foreground whitespace-pre-line">
          {subtitle}
        </p>
        {!continueInApp && error && deliveryMode !== 'webhook' && (
          <div className="mt-2 w-full">
            <CharlieButton
              pill
              block
              onClick={handleManualComplete}
              loading={completing}
            >
              {completing ? t('done.redirecting') : t('done.completeRedirect')}
            </CharlieButton>
          </div>
        )}
      </div>
    </div>
  );
}
